<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT © {{ new Date().getFullYear() }}
      <b-link class="ml-25" href="http://web.agendaassessoria.com.br" target="_blank">Agenda Bank</b-link>
      <span class="d-none d-sm-inline-block">, Todos os Direitos Reservados</span>
    </span>
  </p>
</template>

<script>
  export default {}
</script>
